<template>


    <template v-if="phase.layout_type === 1">

        <div class="template__container" :class="get_container_classes()">

            <div class="content" :class="(!separators_visible()) ? 'no-spacing' : ''">

                <template v-if="separators_visible()">
                
                    <div class="stroke-text" :class="get_stroke_alignment()" :id="'phase'+phase.order">
                        <!-- <p>PHASE <br>{{ text_phase(phase.order + 1) }}</p> -->
                        <p>{{ phase.subline }} <br> {{ phase.title }}</p>
                    </div>

                </template>

                <div class="items">
                    <div class="text__column" :class="get_textcolumn_classes()">
                        <p class="phase-subline" :class="get_subline_classes()">{{ phase.subline }}</p>
                        <p class="phase-title">{{ phase.title }}</p>
                        <div :id="'phase_' + phase.order + '_text'" class="phase-text" :class="get_phasetext_classes()" v-html="phase.text"></div>
                    </div>

                    <div class="mediaslider" :class="get_slider_classes()">
                        <media-slider :media="phase.media" :assetpath="'projects'"></media-slider>
                    </div>
                </div>

            </div>

        </div>

    </template>



    <template v-if="phase.layout_type === 2">

        <div class="template__container" :class="get_container_classes()">

            <div class="content">

                <template v-if="separators_visible()">
                    <div class="stroke-text" :class="get_stroke_alignment()" :id="'phase'+phase.order">
                        <!-- <p>PHASE <br>{{ text_phase(phase.order + 1) }}</p> -->
                        <p>{{ phase.subline }} <br> {{ phase.title }}</p>
                    </div>
                </template>

                <p class="phase-subline" :class="get_subline_classes()">{{ phase.subline }}</p>
                <p class="phase-title center">{{ phase.title }}</p>

                <div class="items">

                    <div class="mediaslider" :class="get_slider_classes()">
                        <media-slider :media="phase.media" :assetpath="'projects'"></media-slider>
                    </div>
                    
                    <div class="text__column" :class="get_textcolumn_classes()">
                        <div :id="'phase_' + phase.order + '_text'"  class="phase-text" :class="get_phasetext_classes()" v-html="phase.text"></div>
                    </div>

                </div>

            </div>

        </div>

    </template>



    <template v-if="phase.layout_type === 3">

        <div class="template__container" :class="get_container_classes()">

            <div class="content">

                <template v-if="separators_visible()">

                    <div class="stroke-text" :class="get_stroke_alignment()" :id="'phase'+phase.order">
                        <!-- <p>PHASE <br>{{ text_phase(phase.order + 1) }}</p> -->
                        <p>{{ phase.subline }} <br> {{ phase.title }}</p>
                    </div>

                </template>

                <p class="phase-subline" :class="get_subline_classes()">{{ phase.subline }}</p>
                <p class="phase-title center">{{ phase.title }}</p>

                <div class="mediaslider" :class="get_slider_classes()">
                    <media-slider :media="phase.media" :assetpath="'projects'"></media-slider>
                </div>
            </div>

            
        </div>

    </template>



    <template v-if="phase.layout_type === 4">

        <div class="template__container" :class="get_container_classes()">

            <div class="content">

                <template v-if="separators_visible()">
                
                    <div class="stroke-text" :class="get_stroke_alignment()" :id="'phase'+phase.order">
                        <!-- <p>PHASE <br>{{ text_phase(phase.order + 1) }}</p> -->
                        <p>{{ phase.subline }} <br> {{ phase.title }}</p>
                    </div>

                </template>


                <p class="phase-subline" :class="get_subline_classes()">{{ phase.subline }}</p>
                <p class="phase-title center">{{ phase.title }}</p>

                <div :id="'phase_' + phase.order + '_text'"  class="phase-text" :class="(phase.order == 2) ? 'text-centered': '' " v-html="phase.text"></div>
            </div>
            
        </div>

    </template>


    
</template>
<script>
export default {
    data(){
        return {}
    },
    props: ['phase', 'all_phases'],
    mounted(){
        const phasetext = document.getElementById('phase_' + this.phase.order + '_text');
        if(phasetext){

            if(window.innerWidth > 837){
                var plannedHeight = 100;

                for (let index = 0; index < phasetext.childNodes.length; index++) {
                    const pElement = phasetext.childNodes[index];
                    plannedHeight+= pElement.clientHeight + 32;
                }

                phasetext.style.minHeight = plannedHeight + 'px';
            }
        }
    },
    methods: {
        get_container_classes(){
            var classes = '';

            const prev_phase = this.all_phases[this.phase.order - 1];


            if(this.phase.order === 0){
                classes += ' first_phase';

                if(this.phase.alignment !== 'center' && this.phase.layout_type !== 1){
                    classes += ' padded-bottom';
                }
            }

            if(this.phase.order === 1){
                classes += ' second_phase';

                if(prev_phase.alignment !== 'center'){
                    classes += ' margin-top-n';
                } else {
                    classes += ' margin-top';
                }

                if(prev_phase.layout_type == 1){
                    classes += ' content-top-margin';
                }
            }

            if(this.phase.order === 1){
                classes += ' padded';
            }
            
            if(this.phase.alignment && this.phase.alignment != "null"){
                classes += ' ' + this.phase.alignment;
            }

            if(this.phase.order === 2 || this.phase.order === 3 || this.phase.order === 4){
                classes += ' black_bg';
            }

            

            return classes;
        },

        get_slider_classes(){
            var classes = '';

            if(this.phase.layout_type == 1){
                classes += ' layout_one';
            }

            if(this.phase.layout_type == 2){
                classes += ' layout_two';
            }

            if(this.phase.layout_type == 3){
                classes += ' layout_three';
            }

            if(this.phase.layout_type == 4){
                classes += ' layout_four';
            }

            if(this.phase.alignment && this.phase.alignment != "null") classes += ' ' + this.phase.alignment;

            if(this.all_phases.length === 1){
                classes += " centered_onephase";
            }


            return classes;
        },

        get_stroke_alignment(){
            if(this.phase.order === 0 || this.phase.order === 2 || this.phase.order === 4){
                return 'right';
            } else {
                return 'left';
            }
        },

        get_subline_classes(){
            var classes = "padded";

            if(this.phase.order == 0){
                classes += ' first';
            }

            if(this.phase.order == 1){
                classes += ' second';
            }

            if(this.phase.order == 2){
                classes += ' third';
            }

            return classes;
        },

        get_textcolumn_classes(){
            var classes = '';

            if(this.phase.order === 1){
                if(this.phase.layout_type === 1){
                    classes += ' centered';
                }
            }

            if(!this.phase.separator_visible){
                classes += ' without-separators';
            }


            return classes;
        },

        text_phase(order){
            if(order === 1) return 'ONE';
            if(order === 2) return 'TWO';
            if(order === 3) return 'THREE';
        },

        get_phasetext_classes(){
            var classes = '';

            if(this.phase.layout_type !== 1 && this.phase.layout_type !== 2){
                classes += ' text-centered';
            }

            if(this.phase.alignment === 'center'){
                classes += ' auto-text-margin';
            }

            if(this.phase.order == 2){
                classes += 'text-centered';
            }

            if(this.phase.order === 2 && classes === ''){
                classes += 'text-margin'; 
            }

            return classes;
        },

        separators_visible(){
            if(this.phase.separator_visible === 1){
                return true;
            }
            return false;
        }
    }
}
</script>
<style lang="scss" scoped>

    .template__container{
        display: flex;
        flex-direction: column;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
        // min-height: 100vh;

        .content{
            width: 100%;
            max-width: 1920px;
            
            margin-left: auto;
            margin-right: auto;
            position: relative;

            .items{
                display: flex;
                flex-direction: row;
                margin-right: 160px;
                margin-left: 207px;

                .text__column{
                    display: flex;
                    flex-direction: column;
                    // width: 100%;
                    // max-width: 526px;
                    margin-top: 113px;
                    margin-left: 42px;
                    margin-right: 42px;

                    &.without-separators{
                        margin-top: 0;
                    }

                    &.centered{
                        justify-content: center;
                    }
                }
            }

        }

        .content.no-spacing{
            .items{
                .text__column{
                    margin-top: 0;
                }

                .mediaslider{
                    margin-top: auto;
                    margin-bottom: 0;
                }
            }
        }

        &.first_phase{
            // padding-bottom: 200px;
            // padding-bottom: 300px;
            padding-bottom: 15%;

            &.padded-bottom{
                padding-bottom: 25%;
            }
        }

        &.second_phase{
            margin-top: -22%;

            &.margin-top{

                .content{
                    padding-top: 5%;
                    margin-top: 10%;
                }
            }

            &.margin-top-n{
                margin-top: -22%;

                &.content-top-margin{
                    .content{
                        margin-top: 12%;
                    }
                }

                
            }
        }

        &.black_bg{
            background: black;
        }

        padding: 72px 0;

        &.padded{
            // padding: 200px 0;
            padding: 100px 0;
        }


        &.left{
            .content{
                .items{
                    flex-direction: row;
                }
            }
        }

        &.right{
            .content{
                .items{
                    flex-direction: row-reverse;
                }
            }
        }

        &.center{
            .content{
                .items{
                    flex-direction: column;
                    justify-content: center;
                }
            }
        }

    }


    .mediaslider{

        &.centered_onephase{
            margin-left: auto !important;
            margin-right: auto !important;
        }
                
        &.layout_one{
            // margin-top: 35vh;
            margin-top: auto;
            margin-bottom: auto;

            &.center{
                margin-top: 130px;
                margin-left: auto;
                margin-right: auto;
            }

            &.right{
                margin-left: 0;
                // margin-right: 120px;
                margin-right: 48px;
            }

            &.left{
                margin-left: 120px;
                margin-right: 0;
            }
        }

        &.layout_two{
            display: flex;
            justify-content: center;

            // margin: 48px auto;
            margin: 48px;

            &.center{
                margin-top: 24px;
                margin-left: auto;
                margin-right: auto;
            }

            &.right{
                // margin-left: 0;
                // margin-right: 120px;
                margin-left: 24px;
                margin-right: 0;
            }

        }

        &.layout_three{
            margin-top: 130px;
        }
    }
    

    .phase-subline{
        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
        font-style: normal;
        // font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        margin: 0;

        color: #ED1163;
        text-transform: uppercase;
        text-align: center;

        padding-top: 42px;

        &.center{
            margin: 0 auto;
        }

        &.padded{

            &.first{
                // padding-top: 250px;
                // padding-top: 60px;
            }

            &.second{
                // padding-top: 250px;
                // padding-top: 60px;
            }

            &.third{
                // padding-top: 120px;
            }
        }
    }

    .phase-title{
        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
        font-style: normal;
        // font-weight: 700;
        font-size: 30px;
        line-height: 36px;
        margin: 0;

        color: #FFFFFF;
        text-transform: uppercase;
        text-align: center;

        &.center{
            margin: 0 auto;
        }
    }
    
    .phase-text{
        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;;
        font-style: normal;
        // font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        margin: 0;

        color: #fff;

        width: 100%;
        max-width: 910px;
        margin: 0 auto;
        text-align: justify;

        display: flex;
        flex-direction: column;
        justify-content: center;

        &.text-centered{
           text-align: center;
        }

        &.auto-text-margin{
            margin-left: auto;
            margin-right: auto;
        }

        &.text-margin{
            margin: 0 24px;
        }

        :deep(p){
            color: white !important;
            margin: 12px 0;
        }
    }

    // .phase-text :deep p{
    //     color: white !important;

    //     &:deep a{
    //         color: white;
    //     }
    // }

    
    :deep(a) {
        color: white;
    }


    .stroke-text{
        width: 100%;
        max-width: 630px;
        border-top: 1px solid #ED1163;
        position: absolute;
        top: 0;
        user-select: none;

        padding-top: 42px;

        &.right{
            right: 160px;
            text-align: right;
        }

        &.left{
            left: 207px;
            text-align: left;
        }

        p{
            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
            font-style: normal;
            font-size: 150px;
            line-height: 136px;
            color: transparent;
            // color: #ED1163;
            -webkit-text-stroke: 1px rgba($color: #ED1163, $alpha: 0.2);
            margin: 0;
            word-break: break-word;
        }
    }

    @media screen and (max-width: 1750px) {

        .template__container .content .items{
            margin-left: 48px;
            margin-right: 48px;
        }

        .stroke-text{
            &.left{
                margin-left: 42px;
            }

            &.right{
                margin-right: 42px;
            }
        }
        
    }

    @media screen and (max-width: 1430px) {

        .template__container{
            .content{
                .items{

                    .text__column{
                        margin-left: 12px;
                        margin-right: 12px;
                    }
                }
            }
        }

    }

    @media screen and (max-width: 1325px) {
        .mediaslider{
            &.layout_one{
                &.right{
                    margin-right: 24px;
                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        .template__container, .template__container.left{
            flex-direction: column;
            padding: 0;

            &.second_phase{
                background: black;
            }

            &.second_phase.margin-top-n{
                margin-top: 0;
            }

            &.second_phase.margin-top-n.content-top-margin{
                margin-top: 0%;

                .content{
                    margin-top: 0;
                }
            }

            .content{

                &.no-spacing{
                    .items{
                        .text__column{
                            margin: 0 !important;
                        }
                    }
                }
                
                .items{
                    flex-direction: column !important;
                    margin-left: 0;
                    margin-right: 0;

                    .text__column{
                        margin-top: 24px;
                        margin-left: 0;
                        margin-right: 0;
                    }
                }
            }
        }

        .stroke-text{
            display: none;
        }

        .mediaslider{
            &.layout_one{
                &.left{
                    margin-left: 0;
                }

                &.right{
                    margin: auto;
                }
            }

            &.layout_two{
                &.center{
                    margin-top: initial;
                    margin-left: initial;
                    margin-right: initial;
                }

                &.right{
                    margin-left: auto;
                    margin-right: auto;
                }
            }

        }

        .phase-text{
            width: 90%;
            font-size: 16px;
            line-height: 16px;
        }

    }

</style>